import React from "react";
import "./Footer.css";

const Footer = () => {
   return <div className="footer">2024 Chelsea Snider</div>;
};

export default Footer;
